export default "__VITE_ASSET__CFeZTeR5__"